import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { getClassNameGenerator } from '../../helper/className';

export class TextWithTooltip extends React.Component {

  get label() {
    const { label, isFirstWordTooltip } = this.props;
    if (!isFirstWordTooltip) {
      return (
        <span className={TextWithTooltip.getClassName('label', true)}>
          {label}
          {this.tooltipIcon}
        </span>
      )
    }
    
    const labelArr = label.split(' ');
    const firstWord = labelArr.shift();
    const rest = labelArr.join(' ');
    return (
      <span className={TextWithTooltip.getClassName('label', true)}>
        <span className={TextWithTooltip.getClassName('label--first-word', true)}>
          {firstWord}
          {this.tooltipIcon}
        </span>
        {' '}
        <span>{rest}</span>
      </span>
    );
  }
  
  get tooltipIcon() {
    const { id, isLeftTooltip } = this.props;
    return (
      <i
        data-tip
        data-for={id}
        data-offset="{'left': 5}"
        className={classNames(
          TextWithTooltip.getClassName('icon'),
          { [TextWithTooltip.getClassName('icon', true, 'left')]: isLeftTooltip },
          'icon-append',
          'fa',
          'fa-question-circle'
        )}
      />
    );
  }
  
  render() {
    const { id, children, delayShow } = this.props;
  
    return (
      <span className={TextWithTooltip.className}>
        {this.label}
        <ReactTooltip
          id={id}
          delayUpdate={delayShow}
          delayShow={delayShow}
          className="esk-tooltip-position"
          getContent={[() => (
            <div className={TextWithTooltip.getClassName('content')}>
              {children}
            </div>
          ), delayShow]}
        >
        
        </ReactTooltip>
    </span>
    );
  }
  
}


TextWithTooltip.className = 'text-with-tooltip';
TextWithTooltip.getClassName = getClassNameGenerator(TextWithTooltip.className);

TextWithTooltip.propTypes = {
  label: PropTypes.any,
  id: PropTypes.string,
  children: PropTypes.any,
  isLeftTooltip: PropTypes.bool,
  delayShow: PropTypes.number,
  isFirstWordTooltip: PropTypes.bool
};

TextWithTooltip.defaultProps = {
  isFirstWordTooltip: false,
  isLeftTooltip: false
};

export default TextWithTooltip;
